import { render } from "./ProveedoresView.vue?vue&type=template&id=fd2c1fc8&scoped=true"
import script from "./ProveedoresView.vue?vue&type=script&lang=js"
export * from "./ProveedoresView.vue?vue&type=script&lang=js"

import "./ProveedoresView.vue?vue&type=style&index=0&id=fd2c1fc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2c1fc8"]])

export default __exports__